export const governorates_ = (id) => `/v2/guest/contact-information/${id}`;
export const submitContact = `/v2/guest/contact-us/us`;
